module.exports = __webpack_public_path__ + "static/img/MN.3e1d28e7.svg";